// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../generated-types'

import gql from 'graphql-tag'
import {
  VenueCardFragmentDoc,
  MatchedVenueCardFragmentDoc,
  DirectEnquiryMessageCardFragmentDoc,
  DeclinedMessageCardFragmentDoc,
} from '../../../Components/Cards/VenueCards/VenueCards.generated'
import { VenueResponseFragmentDoc } from '../../VenueResponsePage/VenueResponsePage.generated'
import { EventInformationFragmentDoc } from '../../../Components/Material/Drawer/Drawer.generated'
import * as Urql from 'urql'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
export type EventResponsesAndEnquiryInformationQueryVariables = Types.Exact<{
  uuid: Types.Scalars['String']
  maxEnquiryResponses: Types.Scalars['Int']
}>

export type EventResponsesAndEnquiryInformationQuery = {
  __typename?: 'Query'
  unmatchedResponses?: {
    __typename?: 'InterestsPage'
    rows: Array<{
      __typename?: 'Interest'
      id: number
      recommended: boolean
      matched: boolean
      guestInitiated: boolean
      matchedAt?: any | null
      message?: {
        __typename?: 'Message'
        id: number
        creationDate: any
        text: string
        email: string
        phone?: string | null
        cardSeen: boolean
        seenAt?: any | null
        relevancyFit: Types.RelevancyFit
        declinedAt?: any | null
        venue?: {
          __typename?: 'Venue'
          name: string
          imageUrl?: string | null
          tour3dUrl?: string | null
          url?: string | null
          spaceName?: string | null
          id: number
          longitude?: number | null
          latitude?: number | null
          description?: string | null
          nearestTransit?: {
            __typename?: 'NearestTransit'
            distance_km: number
            station: string
          } | null
          photos?: Array<{
            __typename?: 'VenuePhoto'
            thumbUrl?: string | null
          }> | null
          documents?: Array<{
            __typename?: 'VenueDocument'
            name: string
            url: string
          }> | null
          spaceFeatures: Array<{
            __typename?: 'SpaceFeature'
            id?: number | null
            name?: string | null
          }>
          spatialConfigurations: Array<{
            __typename?: 'SpatialConfiguration'
            name?: string | null
            capacity?: number | null
          }>
        } | null
        declinedReasons: Array<{
          __typename?: 'DeclineReason'
          id: string
          text: string
        }>
      } | null
      enquiry: {
        __typename?: 'Enquiry'
        uuid: string
        venue?: {
          __typename?: 'Venue'
          name: string
          imageUrl?: string | null
          tour3dUrl?: string | null
          spaceName?: string | null
          id: number
          url?: string | null
          longitude?: number | null
          latitude?: number | null
          description?: string | null
          nearestTransit?: {
            __typename?: 'NearestTransit'
            distance_km: number
            station: string
          } | null
          photos?: Array<{
            __typename?: 'VenuePhoto'
            thumbUrl?: string | null
          }> | null
          documents?: Array<{
            __typename?: 'VenueDocument'
            name: string
            url: string
          }> | null
          spaceFeatures: Array<{
            __typename?: 'SpaceFeature'
            id?: number | null
            name?: string | null
          }>
          spatialConfigurations: Array<{
            __typename?: 'SpatialConfiguration'
            name?: string | null
            capacity?: number | null
          }>
        } | null
        guest?: {
          __typename?: 'Guest'
          firstName: string
          lastName?: string | null
          email?: string | null
          phoneNumber?: string | null
          mobileNumber?: string | null
        } | null
      }
      host: { __typename?: 'User'; id: number; avatar?: string | null }
    }>
  } | null
  matchedResponses?: {
    __typename?: 'InterestsPage'
    rows: Array<{
      __typename?: 'Interest'
      id: number
      matchedAt?: any | null
      matched: boolean
      guestInitiated: boolean
      recommended: boolean
      message?: {
        __typename?: 'Message'
        seenAt?: any | null
        id: number
        creationDate: any
        text: string
        email: string
        phone?: string | null
        cardSeen: boolean
        relevancyFit: Types.RelevancyFit
        declinedAt?: any | null
        venue?: {
          __typename?: 'Venue'
          name: string
          imageUrl?: string | null
          tour3dUrl?: string | null
          url?: string | null
          spaceName?: string | null
          id: number
          longitude?: number | null
          latitude?: number | null
          description?: string | null
          nearestTransit?: {
            __typename?: 'NearestTransit'
            distance_km: number
            station: string
          } | null
          photos?: Array<{
            __typename?: 'VenuePhoto'
            thumbUrl?: string | null
          }> | null
          documents?: Array<{
            __typename?: 'VenueDocument'
            name: string
            url: string
          }> | null
          spaceFeatures: Array<{
            __typename?: 'SpaceFeature'
            id?: number | null
            name?: string | null
          }>
          spatialConfigurations: Array<{
            __typename?: 'SpatialConfiguration'
            name?: string | null
            capacity?: number | null
          }>
        } | null
        declinedReasons: Array<{
          __typename?: 'DeclineReason'
          id: string
          text: string
        }>
      } | null
      enquiry: {
        __typename?: 'Enquiry'
        uuid: string
        venue?: {
          __typename?: 'Venue'
          name: string
          imageUrl?: string | null
          tour3dUrl?: string | null
          spaceName?: string | null
          id: number
          url?: string | null
          longitude?: number | null
          latitude?: number | null
          description?: string | null
          nearestTransit?: {
            __typename?: 'NearestTransit'
            distance_km: number
            station: string
          } | null
          photos?: Array<{
            __typename?: 'VenuePhoto'
            thumbUrl?: string | null
          }> | null
          documents?: Array<{
            __typename?: 'VenueDocument'
            name: string
            url: string
          }> | null
          spaceFeatures: Array<{
            __typename?: 'SpaceFeature'
            id?: number | null
            name?: string | null
          }>
          spatialConfigurations: Array<{
            __typename?: 'SpatialConfiguration'
            name?: string | null
            capacity?: number | null
          }>
        } | null
        guest?: {
          __typename?: 'Guest'
          firstName: string
          lastName?: string | null
          email?: string | null
          phoneNumber?: string | null
          mobileNumber?: string | null
        } | null
      }
      host: { __typename?: 'User'; id: number; avatar?: string | null }
    }>
  } | null
  directEnquiry?: {
    __typename?: 'InterestsPage'
    rows: Array<{
      __typename?: 'Interest'
      id: number
      matched: boolean
      guestInitiated: boolean
      recommended: boolean
      matchedAt?: any | null
      message?: {
        __typename?: 'Message'
        seenAt?: any | null
        id: number
        creationDate: any
        text: string
        email: string
        phone?: string | null
        cardSeen: boolean
        relevancyFit: Types.RelevancyFit
        declinedAt?: any | null
        venue?: {
          __typename?: 'Venue'
          name: string
          imageUrl?: string | null
          tour3dUrl?: string | null
          url?: string | null
          spaceName?: string | null
          id: number
          longitude?: number | null
          latitude?: number | null
          description?: string | null
          nearestTransit?: {
            __typename?: 'NearestTransit'
            distance_km: number
            station: string
          } | null
          photos?: Array<{
            __typename?: 'VenuePhoto'
            thumbUrl?: string | null
          }> | null
          documents?: Array<{
            __typename?: 'VenueDocument'
            name: string
            url: string
          }> | null
          spaceFeatures: Array<{
            __typename?: 'SpaceFeature'
            id?: number | null
            name?: string | null
          }>
          spatialConfigurations: Array<{
            __typename?: 'SpatialConfiguration'
            name?: string | null
            capacity?: number | null
          }>
        } | null
        declinedReasons: Array<{
          __typename?: 'DeclineReason'
          id: string
          text: string
        }>
      } | null
      enquiry: {
        __typename?: 'Enquiry'
        uuid: string
        venue?: {
          __typename?: 'Venue'
          name: string
          imageUrl?: string | null
          tour3dUrl?: string | null
          spaceName?: string | null
          id: number
          url?: string | null
          longitude?: number | null
          latitude?: number | null
          description?: string | null
          nearestTransit?: {
            __typename?: 'NearestTransit'
            distance_km: number
            station: string
          } | null
          photos?: Array<{
            __typename?: 'VenuePhoto'
            thumbUrl?: string | null
          }> | null
          documents?: Array<{
            __typename?: 'VenueDocument'
            name: string
            url: string
          }> | null
          spaceFeatures: Array<{
            __typename?: 'SpaceFeature'
            id?: number | null
            name?: string | null
          }>
          spatialConfigurations: Array<{
            __typename?: 'SpatialConfiguration'
            name?: string | null
            capacity?: number | null
          }>
        } | null
        guest?: {
          __typename?: 'Guest'
          firstName: string
          lastName?: string | null
          email?: string | null
          phoneNumber?: string | null
          mobileNumber?: string | null
        } | null
      }
      host: { __typename?: 'User'; id: number; avatar?: string | null }
    }>
  } | null
  enquiryByUUID?: {
    __typename?: 'Enquiry'
    id: number
    notes?: string | null
    uuid: string
    status: Types.EnquiryStatus
    currency: string
    eventDateFrom: any
    eventDateTo: any
    eventMacroType?: string | null
    location: string
    latitude: number
    longitude: number
    radius: number
    budget: number
    layout: string
    guestsCount: number
    timings?: string | null
    flexibleDates: boolean
    cateringNeeds?: string | null
    createDate: any
    guestId: number
    country: string
    title: string
    audience: Types.Audience
    flexibility: {
      __typename?: 'Flexibility'
      flexibleDates: boolean
      flexibleTimes: boolean
      notes?: string | null
    }
    guest?: {
      __typename?: 'Guest'
      firstName: string
      lastName?: string | null
      email?: string | null
      phoneNumber?: string | null
      mobileNumber?: string | null
    } | null
    optionalSpaceFacilities: Array<{
      __typename?: 'Feature'
      id: number
      name: string
    }>
    requiredSpaceFacilities: Array<{
      __typename?: 'Feature'
      id: number
      name: string
    }>
    spaceStyles?: Array<{
      __typename?: 'SpaceStyle'
      id: string
      label: string
    }> | null
    collection: { __typename?: 'Collection'; label: string }
  } | null
  declinedResponses?: {
    __typename?: 'InterestsPage'
    rows: Array<{
      __typename?: 'Interest'
      id: number
      matched: boolean
      guestInitiated: boolean
      recommended: boolean
      matchedAt?: any | null
      message?: {
        __typename?: 'Message'
        seenAt?: any | null
        declinedAt?: any | null
        id: number
        email: string
        phone?: string | null
        creationDate: any
        text: string
        cardSeen: boolean
        relevancyFit: Types.RelevancyFit
        venue?: {
          __typename?: 'Venue'
          name: string
          imageUrl?: string | null
          tour3dUrl?: string | null
          url?: string | null
          spaceName?: string | null
          id: number
          longitude?: number | null
          latitude?: number | null
          description?: string | null
          nearestTransit?: {
            __typename?: 'NearestTransit'
            distance_km: number
            station: string
          } | null
          photos?: Array<{
            __typename?: 'VenuePhoto'
            thumbUrl?: string | null
          }> | null
          documents?: Array<{
            __typename?: 'VenueDocument'
            name: string
            url: string
          }> | null
          spaceFeatures: Array<{
            __typename?: 'SpaceFeature'
            id?: number | null
            name?: string | null
          }>
          spatialConfigurations: Array<{
            __typename?: 'SpatialConfiguration'
            name?: string | null
            capacity?: number | null
          }>
        } | null
        declinedReasons: Array<{
          __typename?: 'DeclineReason'
          id: string
          text: string
        }>
      } | null
      enquiry: {
        __typename?: 'Enquiry'
        uuid: string
        venue?: {
          __typename?: 'Venue'
          name: string
          imageUrl?: string | null
          tour3dUrl?: string | null
          spaceName?: string | null
          id: number
          url?: string | null
          longitude?: number | null
          latitude?: number | null
          description?: string | null
          nearestTransit?: {
            __typename?: 'NearestTransit'
            distance_km: number
            station: string
          } | null
          photos?: Array<{
            __typename?: 'VenuePhoto'
            thumbUrl?: string | null
          }> | null
          documents?: Array<{
            __typename?: 'VenueDocument'
            name: string
            url: string
          }> | null
          spaceFeatures: Array<{
            __typename?: 'SpaceFeature'
            id?: number | null
            name?: string | null
          }>
          spatialConfigurations: Array<{
            __typename?: 'SpatialConfiguration'
            name?: string | null
            capacity?: number | null
          }>
        } | null
        guest?: {
          __typename?: 'Guest'
          firstName: string
          lastName?: string | null
          email?: string | null
          phoneNumber?: string | null
          mobileNumber?: string | null
        } | null
      }
      host: { __typename?: 'User'; id: number; avatar?: string | null }
    }>
  } | null
}

export type CloseEnquiryMutationVariables = Types.Exact<{
  enquiryAccessSecret: Types.Scalars['String']
  closedSource?: Types.InputMaybe<Types.EnquiryClosedSource>
}>

export type CloseEnquiryMutation = {
  __typename?: 'Mutation'
  CloseEnquiryByAccessSecret?: {
    __typename?: 'Enquiry'
    id: number
    status: Types.EnquiryStatus
  } | null
}

export type MarkCardAsSeenMutationVariables = Types.Exact<{
  messageId: Types.Scalars['Int']
  accessSecret: Types.Scalars['String']
}>

export type MarkCardAsSeenMutation = {
  __typename?: 'Mutation'
  MarkCardAsSeen: { __typename?: 'Message'; cardSeen: boolean }
}

export const EventResponsesAndEnquiryInformationDocument = gql`
  query EventResponsesAndEnquiryInformation(
    $uuid: String!
    $maxEnquiryResponses: Int!
  ) {
    unmatchedResponses: interestsPage(
      filter: {
        enquiryAccessSecret: $uuid
        matched: false
        messageDeclined: false
      }
      sort: { field: id, direction: ASC }
      page: { number: 1, size: $maxEnquiryResponses }
    ) {
      rows {
        id
        ...VenueCard
        ...VenueResponse
      }
    }
    matchedResponses: interestsPage(
      filter: {
        enquiryAccessSecret: $uuid
        matched: true
        guestInitiated: false
        messageDeclined: false
      }
      sort: { field: matchedAt, direction: ASC }
      page: { number: 1, size: $maxEnquiryResponses }
    ) {
      rows {
        id
        ...MatchedVenueCard
        ...VenueResponse
      }
    }
    directEnquiry: interestsPage(
      filter: {
        enquiryAccessSecret: $uuid
        guestInitiated: true
        messageDeclined: false
      }
    ) {
      rows {
        id
        ...DirectEnquiryMessageCard
        ...VenueResponse
      }
    }
    enquiryByUUID: enquiryByAccessSecret(enquiryAccessSecret: $uuid) {
      ...EventInformation
    }
    declinedResponses: interestsPage(
      filter: { enquiryAccessSecret: $uuid, messageDeclined: true }
      page: { number: 1, size: 100 }
    ) {
      rows {
        id
        ...VenueResponse
        ...DeclinedMessageCard
      }
    }
  }
  ${VenueCardFragmentDoc}
  ${VenueResponseFragmentDoc}
  ${MatchedVenueCardFragmentDoc}
  ${DirectEnquiryMessageCardFragmentDoc}
  ${EventInformationFragmentDoc}
  ${DeclinedMessageCardFragmentDoc}
`

export function useEventResponsesAndEnquiryInformationQuery(
  options: Omit<
    Urql.UseQueryArgs<EventResponsesAndEnquiryInformationQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<EventResponsesAndEnquiryInformationQuery>({
    query: EventResponsesAndEnquiryInformationDocument,
    ...options,
  })
}
export const CloseEnquiryDocument = gql`
  mutation CloseEnquiry(
    $enquiryAccessSecret: String!
    $closedSource: EnquiryClosedSource
  ) {
    CloseEnquiryByAccessSecret(
      accessSecret: $enquiryAccessSecret
      closedSource: $closedSource
    ) {
      id
      status
    }
  }
`

export function useCloseEnquiryMutation() {
  return Urql.useMutation<CloseEnquiryMutation, CloseEnquiryMutationVariables>(
    CloseEnquiryDocument
  )
}
export const MarkCardAsSeenDocument = gql`
  mutation MarkCardAsSeen($messageId: Int!, $accessSecret: String!) {
    MarkCardAsSeen(messageId: $messageId, accessSecret: $accessSecret) {
      cardSeen
    }
  }
`

export function useMarkCardAsSeenMutation() {
  return Urql.useMutation<
    MarkCardAsSeenMutation,
    MarkCardAsSeenMutationVariables
  >(MarkCardAsSeenDocument)
}
